import React, { Fragment } from 'react';
import { wrapGrid } from 'client/shared/util';

import { inject, observer } from 'mobx-react';

import { Route, NavLink, Redirect } from 'react-router-dom';
import ManageAccount from './manage-account';
import Footer from '../footer';

@inject('userStore')
@observer
class Account extends React.Component {
    render () {
		const { userStore } = this.props;
		const member = userStore.getLoggedInUser();

        const renderComp = (Comp) => (
            () => ( <Comp member={ member } /> )
        );
        return (
            <Fragment>
                <Route exact
                    path="/account"
                    render={
                        () => ( <Redirect to="/account/manage-account" /> )
                    }
                />

                <Route
                    path="/account/manage-account"
                    render={ renderComp(ManageAccount) }
                />
                <footer>
                    <Footer></Footer>
                </footer>
            </Fragment>
        )
    }
}

export default Account;